export const itemInListReplacer = ary => (newItem, index) => {
  const firstSlice = ary.slice(0, index);
  const lastSlice = ary.slice(index + 1, ary.length);
  return [...firstSlice, newItem, ...lastSlice];
};
